import { reactive, ref, computed } from 'vue';
import { useQuery } from 'vue-query';
import { UseQueryOptions } from 'react-query/types';
import QUERY_KEYS from '@/constants/queryKeys';
import { tokenService } from '@/services/token/token.service';
import useWeb3 from '@/services/web3/useWeb3';
import useNetwork from '../useNetwork';

/**
 * TYPES
 */

/**
 * Fetches all balances for provided tokens.
 */
export default function useBalanceQuery(
  token: string,
  options: UseQueryOptions = {}
) {
  /**
   * COMPOSABLES
   */
  const { account, isWalletReady } = useWeb3();
  const { networkId } = useNetwork();

  /**
   * COMPUTED
   */
  const enabled = computed(() => isWalletReady.value && !!token);

  /**
   * QUERY INPUTS
   */
  const queryKey = reactive(
    QUERY_KEYS.Account.Balance(networkId, account, ref(token))
  );

  const queryFn = async () => {
    console.log('Fetching', token, 'balances');
    return await tokenService.balance.get(account.value, token);
  };

  const queryOptions = reactive({
    enabled,
    ...options
  });

  return useQuery(queryKey, queryFn, queryOptions);
}
